import dates from 'src/utils/dates'

const GETTERS = {
  humans(state, getters, rootState, rootGetters) {
    const persons = rootGetters['tools/persons']

    return persons.map((person) => {
      const { personNameFirst, personNameLast } = person
      const fullName = `${personNameFirst} ${personNameLast}`

      return {
        ...person,
        operator: 'incl',
        text: fullName,
        value: fullName,
      }
    })
  },

  internals(state, getters) {
    const { humans } = getters

    return humans.filter((human) => {
      const { access = {} } = human

      return access.role === 'internal'
    })
  },
  async delegates(state, getters, rootState, rootGetters) {
    const haveCurrentUser = rootGetters['auth/haveCurrentUser']

    if (!haveCurrentUser) {
      return []
    }

    const { humans } = getters

    if (!humans) {
      return []
    }

    const { searchResults } = rootState.tools
    const searchEndpoint = searchResults.endpoints.person
    const personCollection = await searchEndpoint.items.list

    if (!personCollection) {
      return []
    }

    const currentUser = rootGetters['auth/currentUser']
    const hasAccessToOrgTimeEntries = rootGetters['auth/hasAccessToOrgTimeEntries']
    const { personId: currentPersonId } = currentUser

    return personCollection.reduce((delegates, person) => {
      const isSelf = person.personId === currentPersonId
      const isManager = person.managerPersonId === currentPersonId

      if (isSelf || isManager || hasAccessToOrgTimeEntries) {
        const { personId, personNameFirst, personNameLast } = person
        const fullName = `${personNameFirst} ${personNameLast}`

        delegates.push({
          ...person,
          operator: 'incl',
          text: fullName,
          value: personId,
        })
      }

      return delegates
    }, [])
  },

  minCalendarDate() {
    return dates.getStartOfMonth()
  },
  maxCalendarDate() {
    return dates.getEndOfMonth()
  },
  successMessage(state) {
    const { action } = state

    if (action === 'create') return 'Added'
    if (action === 'update') return 'Edited'
    if (action === 'delete') return 'Deleted'

    return 'Success'
  },
  errorMessage(state) {
    const { action } = state

    if (action === 'create') return 'Failed to Add. Please try again.'
    if (action === 'update') return 'Failed to Edit. Please try again.'
    if (action === 'delete') return 'Failed to Delete. Please try again.'

    return 'Error'
  },
}

export default GETTERS
